/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeTriangleARightIcon16Light } from './ArrowShapeTriangleARightIcon16Light';
import { ArrowShapeTriangleARightIcon16Regular } from './ArrowShapeTriangleARightIcon16Regular';
import { ArrowShapeTriangleARightIcon16Solid } from './ArrowShapeTriangleARightIcon16Solid';
import { ArrowShapeTriangleARightIcon20Light } from './ArrowShapeTriangleARightIcon20Light';
import { ArrowShapeTriangleARightIcon20Regular } from './ArrowShapeTriangleARightIcon20Regular';
import { ArrowShapeTriangleARightIcon20Solid } from './ArrowShapeTriangleARightIcon20Solid';
import { ArrowShapeTriangleARightIcon24Regular } from './ArrowShapeTriangleARightIcon24Regular';
import { ArrowShapeTriangleARightIcon24Solid } from './ArrowShapeTriangleARightIcon24Solid';
import { ArrowShapeTriangleARightIcon32Regular } from './ArrowShapeTriangleARightIcon32Regular';
import { ArrowShapeTriangleARightIcon64Regular } from './ArrowShapeTriangleARightIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeTriangleARightIcon16Light,
        regular: ArrowShapeTriangleARightIcon16Regular,
        solid: ArrowShapeTriangleARightIcon16Solid,
    },
    20: {
        light: ArrowShapeTriangleARightIcon20Light,
        regular: ArrowShapeTriangleARightIcon20Regular,
        solid: ArrowShapeTriangleARightIcon20Solid,
    },
    24: {
        regular: ArrowShapeTriangleARightIcon24Regular,
        solid: ArrowShapeTriangleARightIcon24Solid,
    },
    32: {
        regular: ArrowShapeTriangleARightIcon32Regular,
    },
    64: {
        regular: ArrowShapeTriangleARightIcon64Regular,
    },
};
export var ArrowShapeTriangleARightIcon = forwardRef('ArrowShapeTriangleARightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
